<template>
  <div
    class="border-surface-container-highest rounded-extra-large focus:outline-primary flex flex-col items-center justify-center border p-4 focus:outline-3 focus:outline-offset-2"
    tabindex="0"
  >
    <div class="xs:py-6 flex grow flex-row items-center py-2 lg:grow-0 lg:items-end">
      <h3
        class="text-title-large md:text-headline-medium w-full max-w-2xl text-center text-balance"
      >
        {{ question.content }}
      </h3>
    </div>
    <ScaleBasedQuestion
      v-if="
        feedbackType == FeedbackType.ScaleBased || feedbackType == FeedbackType.TextualAndScaleBased
      "
      :key="question.id"
      :type="feedbackType"
      :model-value="feedback?.value"
      @update:model-value="(value) => updateValue(value)"
      :question-id="question.id"
      :scale="scale!"
      :scale-item-descriptions="question.scaleItemDescriptions"
      :current-selected-index="currentSelectedIndex"
    />
    <TextualQuestion
      v-if="
        feedbackType == FeedbackType.Textual || feedbackType == FeedbackType.TextualAndScaleBased
      "
      :model-value="feedback?.text"
      @update:model-value="(text) => updateText(text)"
      :auto-focus-enabled="false"
    />
  </div>
</template>
<script lang="ts" setup>
  import type { Scale } from '@/core/models/scale'
  import { FeedbackType } from '@/core/models/feedback-type'
  import ScaleBasedQuestion from '../scale-based-questions/ScaleBasedQuestion.vue'
  import TextualQuestion from '../textual-questions/TextualQuestion.vue'
  import type { JSONContent } from '@tiptap/vue-3'
  import { computed } from 'vue'

  interface Props {
    question: {
      readonly id: string
      readonly content: string
      readonly scaleItemDescriptions?: ReadonlyArray<string>
    }
    feedbackType: FeedbackType
    scale?: Scale
    feedback?: { value?: number; text?: JSONContent }
  }

  // const { isOpen, closeDialog, openDialog } = useDialog()

  const emits = defineEmits<{
    (e: 'update:feedback', feedback: { value?: number; text?: JSONContent }): void
  }>()

  const props = defineProps<Props>()

  const updateValue = (value?: number) => {
    emits('update:feedback', { value: value })
  }

  const updateText = (text?: JSONContent) => {
    emits('update:feedback', { text: text })
  }

  const currentSelectedIndex = computed(() => {
    const index = props.scale?.items.findIndex((item) => item.value == props.feedback?.value)

    if (index && index >= 0) return index

    return 0
  })

  // const hasLabels = computed(() => props.labels.length > 0)

  // const labelKeys = computed(() => {
  //   return feedback.value.labels.map((label) => label.key)
  // })

  // const updateLabel = (label: FeedbackLabel) => {
  //   if (labelKeys.value.includes(label.key)) {
  //     feedback.value.labels = feedback.value.labels.filter((l) => l.key !== label.key)
  //   } else {
  //     feedback.value.labels.push(label)
  //   }

  //   emit('update:modelValue', feedback.value)
  // }
</script>
